import * as React from 'react';

import Move16 from './Move16';

export const move16 = () => <Move16 />;

export default {
    title: 'Icon/Fill/Move16',
    component: Move16,
    parameters: {
        notes: "`import Move16 from 'box-ui-elements/es/icon/fill/Move16';`",
    },
};
